import * as React from 'react';
import Div100vh from 'react-div-100vh'
import './styles/styles.scss';
import './styles/hamburgers.scss'
import Graphics from './components/Graphics';
import { Controls } from 'react-three-gui';

const isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))

export default function App() {
  const [loaded, setLoaded] = React.useState(false)
  const [playing, setPlaying] = React.useState(false);
  const [mobile, setMobile] = React.useState(isMobile);
  const [counter, setCounter] = React.useState(0);
  const previousTime = React.useRef(0)

  const [leftTrigger, setLeftTrigger] = React.useState(0);
  const [rightTrigger, setRightTrigger] = React.useState(0);

  const onBeat = () => {
    const currentTime = Date.now()
    const delta = currentTime - previousTime.current

    if (delta > 200) {
      previousTime.current = currentTime
      setCounter((counter + 1) % 2)

      if (!counter) setLeftTrigger((leftTrigger + 1) % 2)
      if (counter) setRightTrigger((rightTrigger + 1) % 2)
    }
  }

  React.useEffect(() => {
    events.on("onBeat", onBeat);
    return () => {
      events.off("onBeat", onBeat);
    }
  }, [counter, leftTrigger, rightTrigger])

  const mousePressed = () => {
    if (playing) return
    setPlaying(true)
    source.start();
  }

  const [guiCollapsed, setGuiCollapsed] = React.useState(true)
  const handleHamburger = () => {
    setGuiCollapsed(!guiCollapsed)
  }

  return (
    <>
      <button className={`hamburger hamburger--spin ${guiCollapsed ? '' : 'is-active'}`} type="button" onClick={handleHamburger}>
        <span className="hamburger-box">
          <span className="hamburger-inner"></span>
        </span>
      </button>
      <div className={`overlay ${loaded ? 'hidden' : ''}`}>
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
      </div>
      <div className="App" onClick={mousePressed}>
        <div className={`playButton ${loaded ? '' : 'hidden'} ${playing ? 'playing' : ''}`}></div>
        <Div100vh style={{ height: `100rvh` }} className="vis-container">
          <Graphics setLoaded={setLoaded} leftTrigger={leftTrigger} rightTrigger={rightTrigger} mobile={mobile} isPlaying={playing}></Graphics>
          <div className={`gradientControl ${mobile ? 'mobile' : ''} ${guiCollapsed ? 'hidden' : ''}`}>
            <Controls />
          </div>
        </Div100vh>
      </div>
    </>
  );
}
